export default {
  username: 'บัญชีผู้ใช้',
  password: 'รหัสผ่าน',
  firstName: 'ชื่อ',
  lastName: 'นามสกุล',
  role: 'สิทธิ์'
};
